/**
 * Letter Zoom Animation Module (ACTIVE - Production)
 *
 * Standalone module for Letter Zoom animation variant.
 * Camera zoom-out paradigm with O(1) performance.
 *
 * ## Status: ACTIVE
 *
 * This is the ACTIVE implementation used by LetterThrowingAnimation.web.tsx.
 * ALL letterZoom changes should go to this folder ONLY.
 *
 * Reconciliation completed 2025-12-12:
 * - Inline LetterZoomExperienceAnimation deleted from parent file (666 lines)
 * - Parent file imports from this module for variant === 'letterZoom'
 * - Backup deleted 2025-12-15 (code cleanup, 2825 lines removed)
 *
 * ## Platform Support
 *
 * | Platform | Status | Implementation |
 * |----------|--------|----------------|
 * | Web      | ✅ Full | RAF-based animation (LetterZoomAnimation.web.tsx) |
 * | iOS      | ⚠️ Fallback | Falls back to LetterThrowingAnimation |
 * | Android  | ⚠️ Fallback | Falls back to LetterThrowingAnimation |
 *
 * Metro bundler automatically resolves:
 * - Web builds → LetterZoomAnimation.web.tsx
 * - Native builds → LetterZoomAnimation.native.tsx (fallback stub)
 *
 * @todo Native implementation with Reanimated 3 (estimated: 12-16 hours)
 *
 * @example
 * import { LetterZoomAnimation } from './letterZoom';
 * <LetterZoomAnimation text="..." onComplete={() => {}} />
 */

// Main component (Metro resolves .web.tsx or .native.tsx based on platform)
export { default as LetterZoomAnimation } from './LetterZoomAnimation';

// Utilities (for reuse in other animations)
export {
  getZoomStepText,
  getZoomGlowColor,
  findStepIndex,
  getStepFraction,
  getStepBoundaries,
} from './letterZoomUtils';

// Shared utilities (for reuse across animation variants)
export {
  splitIntoLines,
  getCategoryFromScore,
  CATEGORY_STYLES,
} from './sharedAnimationUtils';

// Styles (for reuse or extension)
export { styles as letterZoomStyles } from './letterZoomStyles';
